// MediaRecorder wrapper. Handles iOS/Android codec differences.

function getSupportedMimeType() {
  const types = [
    'audio/webm;codecs=opus',
    'audio/webm',
    'audio/ogg;codecs=opus',
    'audio/mp4',
  ]
  return types.find(t => MediaRecorder.isTypeSupported(t)) ?? ''
}

export class Recorder {
  #mediaRecorder = null
  #chunks = []
  #stream = null
  #mimeType = getSupportedMimeType()

  get isRecording() {
    return this.#mediaRecorder?.state === 'recording'
  }

  async start() {
    this.cancel() // stop any previous session

    this.#stream = await navigator.mediaDevices.getUserMedia({ audio: true })
    this.#chunks = []

    this.#mediaRecorder = new MediaRecorder(this.#stream, {
      mimeType: this.#mimeType || undefined,
    })

    this.#mediaRecorder.ondataavailable = e => {
      if (e.data.size > 0) this.#chunks.push(e.data)
    }

    this.#mediaRecorder.start(100) // collect chunks every 100 ms
  }

  // Stop recording and return the audio Blob.
  stop() {
    return new Promise((resolve, reject) => {
      if (!this.#mediaRecorder || this.#mediaRecorder.state === 'inactive') {
        reject(new Error('Not recording'))
        return
      }
      this.#mediaRecorder.onstop = () => {
        const blob = new Blob(this.#chunks, { type: this.#mimeType || 'audio/webm' })
        this.#cleanup()
        resolve(blob)
      }
      this.#mediaRecorder.stop()
    })
  }

  // Cancel without returning audio.
  cancel() {
    if (this.#mediaRecorder && this.#mediaRecorder.state !== 'inactive') {
      this.#mediaRecorder.onstop = null
      this.#mediaRecorder.stop()
    }
    this.#cleanup()
  }

  #cleanup() {
    this.#stream?.getTracks().forEach(t => t.stop())
    this.#stream = null
    this.#mediaRecorder = null
    this.#chunks = []
  }
}
